import React from "react";
import PaymentRouter from './Payment/Router';
export { getFields } from './Payment/Router';

export default function PaymentSupplierRouter(props){
    return <PaymentRouter {...props} mode='SUPPLIER' />;
}